
const providerLogos = [
  { name: 'UT Southwestern Medical Center', icon: 'ri-hospital-line' },
  { name: 'Baylor Scott & White Health', icon: 'ri-heart-pulse-line' },
  { name: 'Texas Health Presbyterian', icon: 'ri-stethoscope-line' },
  { name: 'Parkland Health', icon: 'ri-first-aid-kit-line' },
  { name: 'Children\'s Medical Center', icon: 'ri-empathize-line' },
  { name: 'Medical City Dallas', icon: 'ri-building-2-line' },
];

export default function ProviderNetwork() {
  return (
    <section className="py-16 bg-white border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-10">
          <p className="text-sm font-semibold tracking-widest text-gray-400 uppercase mb-2">Our Plans Include Access To</p>
          <h4 className="text-xl font-heading font-bold text-primary">
            <a href="/insurance-plans" className="hover:text-secondary transition-colors">Dallas&apos;s Premier Medical Institutions</a>
          </h4>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {providerLogos.map((provider, index) => (
            <div
              key={index}
              className="flex flex-col items-center gap-3 p-5 rounded-lg bg-gray-50 hover:bg-sky-50 transition-all duration-300 group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm group-hover:shadow-md transition-all">
                <i className={`${provider.icon} text-2xl text-secondary`}></i>
              </div>
              <span className="text-xs font-medium text-gray-600 text-center leading-tight">{provider.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
